import CustomTimeInput from './field/CustomTimeInput'
import EmailPreviewArea from './field/EmailPreviewArea'
import EmailPreviewInput from './field/EmailPreviewInput'
import EmailPreviewInputBtn from './field/EmailPreviewInputBtn'
import ReactForm from './field/Form'
import FormAsyncSelect from './field/FormAsyncSelect'
import FormCheckbox from './field/FormCheckbox'
import FormCheckGroup from './field/FormCheckGroup'
import FormColorSelect from './field/FormColorSelect'
import FormCombinedInput from './field/FormCombinedInput/FormCombinedInput'
import FormDatepicker from './field/FormDatepicker'
import FormInput from './field/FormInput'
import FormSelect from './field/FormSelect'
import FormSocialInput from './field/FormSocialInput/FormSocialInput'
import FormSwitch from './field/FormSwitch/FormSwitch'
import FormTextArea from './field/FormTextArea'
import FormTextAreaWithTags from './field/FormTextAreaWithTags'
import PictureEditInput from './field/PictureEditInput'
import PreviewArea from './field/PreviewArea'
import PreviewInput from './field/PreviewInput'
import { withField } from './support'
import FieldRow from './support/FieldRow'

export const Form = ReactForm

export class Field {
   static Input = withField(FormInput)
   static Select = withField(FormSelect)
   static AsyncSelect = withField(FormAsyncSelect)
   static Date = withField(FormDatepicker)
   static Checkbox = withField(FormCheckbox)
   static CheckboxGroup = withField(FormCheckGroup)
   static TextArea = withField(FormTextArea)
   static TextAreaWithTags = withField(FormTextAreaWithTags)
   static Switch = withField(FormSwitch)
   static ColorSelect = withField(FormColorSelect)
   static CombinedInput = withField(FormCombinedInput)
   static SocialInput = withField(FormSocialInput)
   static PreviewBtn = withField(EmailPreviewInputBtn)
   static Row = FieldRow
   static PreviewInput = withField(PreviewInput)
   static PreviewArea = withField(PreviewArea)
   static EmailPreInput = withField(EmailPreviewInput)
   static EmailPreArea = withField(EmailPreviewArea)
   static CustomInput = withField(CustomTimeInput)
   static PictureInput = withField(PictureEditInput)
}
